import { env } from "./env";

const IMAGES_HASH =
  import.meta.env.VITE_CLOUDFLARE_IMAGES_HASH ?? "zOWgMvBjUoMHITUiHXXuPQ";

/**
 * URL for a media row's Cloudflare Images delivery.
 *
 * The cf_image_id is written to media.exif by the ingest worker once
 * the original lands in R2 + is pushed to CF Images. Until then we
 * fall back to a CSS placeholder.
 */
export function mediaUrl(
  exif: Record<string, unknown> | null | undefined,
  variant: string = "public",
): string | null {
  const cfImageId = exif?.cf_image_id as string | undefined;
  if (!cfImageId) return null;
  return `https://imagedelivery.net/${IMAGES_HASH}/${cfImageId}/${variant}`;
}

export function mediaTransformUrl(
  exif: Record<string, unknown> | null | undefined,
  {
    w,
    h,
    fit = "cover",
  }: { w: number; h: number; fit?: "cover" | "contain" | "scale-down" },
): string | null {
  const cfImageId = exif?.cf_image_id as string | undefined;
  if (!cfImageId) return null;
  return `https://imagedelivery.net/${IMAGES_HASH}/${cfImageId}/w=${w},h=${h},fit=${fit}`;
}

// Used to silence the unused-import lint when env stays here.
void env;
